import { render, staticRenderFns } from "./OrganismTemplateHistory.vue?vue&type=template&id=a989ef28&scoped=true&"
import script from "./OrganismTemplateHistory.vue?vue&type=script&lang=js&"
export * from "./OrganismTemplateHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTemplateHistory.vue?vue&type=style&index=0&id=a989ef28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a989ef28",
  null
  
)

export default component.exports